import { PageHeader } from "@ant-design/pro-components";
import styled from "styled-components";
export const FormsPageHeader = styled(PageHeader)`
  background-color: white;

  .ant-page-header-heading-title {
    color: white;
    margin-left: -40px;
    position: absolute;
  }

  .ant-page-header-heading-sub-title {
    color: white;
  }

  .ant-page-header-back-button {
    color: white;
  }

  .ant-breadcrumb a {
    color: white;
  }

  .ant-breadcrumb-separator {
    color: white;
  }

  .ant-breadcrumb > span:last-child {
    color: #ccc;
  }
  .ant-btn:hover,
  .ant-btn:focus,
  .ant-btn:active {
    background: none;
  }

  @media screen and (min-width: 310px) and (max-width: 450px) {
    .ant-page-header-heading-left {
      width: 100%;
    }

    .ant-page-header-heading-extra > *:first-child {
      margin-left: 12px;
    }

    .ant-page-header-heading-extra > :nth-child(2) {
      margin-top: 10px;
    }

    .ant-page-header-heading-extra > :nth-child(3) {
      margin-top: 10px;
    }
    .ant-page-header-heading-extra > :nth-child(4) {
      margin-top: 10px;
    }
    .ant-page-header-heading-extra {
      white-space: unset;
    }
    .ant-btn {
      line-height: 0.7;
    }
  }
`;
